/**
 * LupaSearch / PDP URL slug `code` values to track for out-of-stock interest.
 * Update this list when new hardcoded OOS products should be measured.
 * Examples match Lupa `code` (URL path last segment), e.g. apple-iphone-14.
 */
const TRACKED_OUT_OF_STOCK_PRODUCT_CODES = [
    'xiaomi-redmi-a3',
    'apple-iphone-18-pro',
    'apple-iphone-18-pro-max',
] as const;

const trackedOutOfStockProductCodeSet = new Set(TRACKED_OUT_OF_STOCK_PRODUCT_CODES.map((code) => code.toLowerCase()));

export const isTrackedOutOfStockProductCode = (productCode?: string | null): boolean => {
    if (!productCode) {
        return false;
    }

    return trackedOutOfStockProductCodeSet.has(productCode.toLowerCase());
};
